<ion-header>
  <ion-toolbar>
    <ion-button fill="clear" (click)="dismiss()"> Cancel </ion-button>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <super-step-item
    count="1"
    [isTopLine]="false"
    [success]="collectionTemplate?.purpose?.length > 0">
    <ion-list>
      <ion-item>
        <ion-label position="stacked">Template Name</ion-label>
        <ion-input
          class="template-name-input"
          placeholder="Enter name here"
          [(ngModel)]="collectionTemplate.purpose"></ion-input>
      </ion-item>
    </ion-list>
  </super-step-item>

  <super-step-item
    count="2"
    [success]="collectionTemplate?.acceptedIds?.length > 0">
    <ion-list>
      <ion-item button="" (click)="openIdSetter()">
        <ion-label>
          <h2>Set IDs</h2>
          <p>Click to choose IDs that you want to collect from your customer</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </super-step-item>

  <super-step-item
    count="3"
    [isBottomLine]="false"
    [success]="collectionTemplate?.otherInfo?.length > 0">
    <ion-list>
      <ion-item
        button=""
        (click)="openFieldSetter()"
        [class.step-complete]="collectionTemplate?.acceptedIds?.length > 0">
        <ion-label>
          <h2>Set Other Field</h2>
          <p>Click to add fields like Name, Phone, Email, etc.</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </super-step-item>

  <page-action>
    <super-button
      *ngIf="!collectionTemplate._id"
      [action]="createTemplate"
      width="full"
      [showError]="true"
      >Create Template
    </super-button>
    <super-button
      *ngIf="collectionTemplate._id"
      [action]="updateTemplate"
      width="full"
      [showError]="true"
      >Update
    </super-button>
  </page-action>
</ion-content>
